import { render } from "./acceptInvitation.vue?vue&type=template&id=679529ae&scoped=true"
import script from "./acceptInvitation.vue?vue&type=script&lang=js"
export * from "./acceptInvitation.vue?vue&type=script&lang=js"

import "./acceptInvitation.vue?vue&type=style&index=0&id=679529ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679529ae"]])

export default __exports__